<template>
    <section
        class="search-geolink flow-column"
        :class="{ 'show-more': showMore }"
        v-if="basePath && hasAnyLinks"
        comp="searchFilterlink"
    >
        <div>
            <h2 class="f4 text-bold">Narrow your search</h2>
        </div>
        <ul>
            <li v-if="priceLinks.length">
                <button :class="{ active: tab === 'price' }" type="button" @click="toggle('price')">
                    Price
                </button>
            </li>
            <li v-if="propertyTypeLinks.length">
                <button :class="{ active: tab === 'propertyType' }" type="button" @click="toggle('propertyType')">
                    Property type
                </button>
            </li>
            <li v-if="featuredLinks.length">
                <button :class="{ active: tab === 'featured' }" type="button" @click="toggle('featured')">
                    Featured
                </button>
            </li>
        </ul>
        <div class="search-linklist" :class="{ show: tab === 'price' }" v-if="priceLinks.length">
            <div v-for="link in priceLinks" :key="link.href">
                <a :href="link.href" class="link">
                    {{ link.text }}
                </a>
            </div>
        </div>
        <div class="search-linklist" :class="{ show: tab === 'propertyType' }" v-if="propertyTypeLinks.length">
            <div v-for="link in propertyTypeLinks" :key="link.href">
                <a :href="link.href" class="link">
                    {{ geoDisplayName }} <b class="text-bold">{{ link.text }}</b> {{ link.suffix ? ' ' + link.suffix : '' }}
                </a>
            </div>
        </div>
        <div class="search-linklist" :class="{ show: tab === 'featured' }" v-if="featuredLinks.length">
            <div v-for="link in featuredLinks" :key="link.href">
                <a :href="link.href" class="link">
                    {{ geoDisplayName }} <b class="text-bold">{{ link.text }}</b> {{ link.suffix ? ' ' + link.suffix : '' }}
                </a>
            </div>
        </div>
        <button v-if="currentList && currentList.length > 5" type="button" @click="toggleShowMore">
            {{ showMore ? 'Show Less' : 'Show More' }}
            <i :class="showMore ? 'icon-angle-up' : 'icon-angle-down'"></i>
        </button>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import format from '@/common/utilities/format';

//'forSale', 'singleFamily', 'condo', 'multiFamily', 'land', 'mobile'
const PROPERTY_TYPE_LINKS = [
    { path: 'single-family/', text: 'single family', suffix: 'homes for sale', countKey: 'singleFamilyCount' },
    { path: 'condos/', text: 'condos and townhouses ', suffix: 'for sale', countKey: 'condoCount' },
    { path: 'multi-family/', text: 'multi-family and duplexes', suffix: 'homes for sale', countKey: null },
    { path: 'mobile/', text: 'mobile and manufactured', suffix: 'homes for sale', countKey: null },
    { path: 'land/', text: 'lots and land', suffix: 'for sale', countKey: null },
];


const FEATURED_LINKS_FOR_SALE = [
    { path: 'new-7/', text: 'new listings', suffix: 'for sale', countKey: 'homeNewCount' },
    { path: 'new-construction/', text: 'new construction', suffix: 'for sale', countKey: 'newConstructionHomesCount' },
    { path: 'rentals/', text: 'rentals', suffix: '', countKey: null },
    { path: 'rentals/condos/', text: 'apartments', suffix: 'for rent', countKey: 'condoCount' },
    { path: 'rentals/single-family/', text: 'single family', suffix: 'for rent', countKey: 'singleFamilyCount' },
    { path: 'sold/', text: 'recently sold', suffix: 'homes', countKey: null },
    { path: 'foreclosed/', text: 'foreclosed', suffix: 'homes for sale', countKey: null },
    { path: 'open-houses/', text: 'open', suffix: 'houses', countKey: 'homeOpenCount' },
    // { path: 'reduced-30/', text: 'price reduced', suffix: 'homes for sale', countKey: 'priceReducedCount' },
];

export default {
    name: 'searchFilterLink',
    data() {
        return {
            selectedTab: '',
            showMore: false,
        };
    },
    methods: {
        toggle(type) {
            this.selectedTab = type;
        },
        toggleShowMore() {
            this.showMore = !this.showMore;
        },
        getPriceRangeText(filterStr) {
            const match = filterStr && filterStr.match(/price-(\d+)-(\d+)/);
            if (match) {
                const maxPrice = parseInt(match[2], 10);
                const formatPrice = format.friendlyPrice;
                return `Under $${formatPrice(maxPrice)}`;
            }
            return '';
        },
        createPriceLinks(priceRangeFilters, baseUrl) {
            if (!priceRangeFilters) return [];

            return priceRangeFilters
                .map((item) => {
                    const displayName = this.getPriceRangeText(item.attribute_id);
                    const fullURL = `${this.glb.appUrl}${baseUrl}${item.attribute_id}/`;
                    return displayName && fullURL ? { text: displayName, href: fullURL } : null;
                })
                .filter(Boolean)
                .filter((link) => !this.isMatchCurrentPath(link.href));
        },
        isMatchCurrentPath(url) {
            if(!this.currentPathArr || !this.currentPathArr.length){
                return false
            }
            let path = url.replace(this.glb.appUrl, '').replace(/\/?$/, '');
            let comparePath = path.split('/');
            let currentPath = this.currentPathArr;
            if(comparePath.length !== currentPath.length){
                return false
            }
            for(let i = 0; i < comparePath.length; i++){
                if (!currentPath.includes(comparePath[i])) {
                    return false;
                }
            }
            return true;
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['msp', 'geo']),
        currentPathArr(){
            if(this.msp?.viewUrl ){
                let path =this.msp.viewUrl.split('/@')[0];
                path = path.replace(/^\//, '');
                path = path.replace(/\/?$/, '');
                return path.split('/');
            }
            return [];
        },
        tab() {
            if (this.selectedTab) {
                return this.selectedTab;
            }
            if (this.priceLinks.length) {
                return 'price';
            }
            if (this.propertyTypeLinks.length) {
                return 'propertyType';
            }
            if (this.featuredLinks.length) {
                return 'featured';
            }
            return null;
        },
        hasAnyLinks() {
            return this.priceLinks.length || this.propertyTypeLinks.length || this.featuredLinks.length;
        },
        geoDisplayName() {
            const { geo } = this;
            if (!geo) return '';
            switch (geo.geoType) {
                case 'ZIPCODE':
                    return geo.zipcode ? `${geo.zipcode}, ${geo.state}` : '';
                case 'NEIGHBORHOOD':
                    return geo.neighborhood || '';
                case 'CITY':
                case 'ADDRESS':
                    return geo.city || '';
                case 'COUNTY':
                    return geo.county || '';
                case 'STATE':
                    return geo.state || '';
                default:
                    return geo.city || geo.zipcode || '';
            }
        },
        basePath() {
            const geoPath = this.glb?.geo.geoPath || '';
            if (!geoPath) return '';
            if(![ 'CITY', 'NEIGHBORHOOD', 'ZIPCODE'].includes(this.glb.geo.geoType)) {
                return '';
            }
            return (geoPath.replace(/rentals\/?$/, '') || '').replace(/\/?$/, '/');
        },
        priceLinks() {
            if (!this.basePath) return [];
            const { refinedInventoryCounts, filter } = this.msp;

            if (!refinedInventoryCounts || !filter || filter.rentals) {
                return [];
            }
            const { priceRangeFilters } = refinedInventoryCounts;
            return this.createPriceLinks(priceRangeFilters, this.basePath);
        },
        propertyTypeLinks() {
            if (!this.basePath) return [];
            const filters = PROPERTY_TYPE_LINKS;
            const geoType = this.glb?.geo?.geoType;
            const geoKey = geoType === 'ZIPCODE' ? 'zipcode' : geoType === 'NEIGHBORHOOD' ? 'neighborhood' : 'city';
            const inventory = this.glb.listingCountObj?.[geoKey];

            return filters
                .filter((item) => {
                    if (!inventory || typeof inventory[item.countKey] === 'undefined') {
                        return true; // not mentioned -> show
                    }
                    return inventory[item.countKey] > 0; // show if count > 0, hide if 0
                })
                .map((item) => ({
                    href: `${this.glb.appUrl}${this.basePath}${item.path}`,
                    text: item.text,
                    suffix: item.suffix,
                }))
                .filter((link) => !this.isMatchCurrentPath(link.href));
        },
        featuredLinks() {
            if (!this.basePath) return [];
            const filters =  FEATURED_LINKS_FOR_SALE;
            const geoType = this.glb?.geo?.geoType;
            const geoKey = geoType === 'ZIPCODE' ? 'zipcode' : geoType === 'NEIGHBORHOOD' ? 'neighborhood' : 'city';
            const inventory = this.glb.listingCountObj?.[geoKey];

            return filters
                .filter((item) => {
                    if (!item.countKey || !inventory || typeof inventory[item.countKey] === 'undefined') {
                        return true;
                    }
                    return inventory[item.countKey] > 0;
                })
                .map((item) => ({
                    href: `${this.glb.appUrl}${this.basePath}${item.path}`,
                    text: item.text,
                    suffix: item.suffix,
                }))
                .filter((link) => !this.isMatchCurrentPath(link.href));
        },
        currentList() {
            if (this.tab === 'price') return this.priceLinks;
            if (this.tab === 'propertyType') return this.propertyTypeLinks;
            if (this.tab === 'featured') return this.featuredLinks;
            return null;
        },
    },
};
</script>

<style lang="scss">
@use './search-geolink.scss' as *;
</style>
